;(function($) {

	'use strict';


	$.fn.search = function () {
		var _this = this, __init, _initEvents, _openSearch, _closeSearch, _doSearch, prefersReduced, firstFocusable,lastFocusable, _tabTrap, _findFirstLastFocusable, _hideContainer, _isFocusable;
        var openCtrl,closeCtrl,searchContainer,inputSearch,resultsContainer;
        var transitionListenerAdded = false;
        var xhr;
        var searchPhrase = "";
        var searchTimeout;

        _initEvents = function() {
            openCtrl.on('click', _openSearch);
            closeCtrl.on('click', _closeSearch);
            inputSearch.on('keyup', function(ev) {
                window.clearTimeout(searchTimeout);
                if(typeof xhr !== 'undefined'){
                    xhr.abort();
                }

                // escape key.
                if( ev.keyCode == 27 ) {
                    _closeSearch();
                }

                if(ev.keyCode > 46 && ev.keyCode < 91){
                    searchPhrase += ev.key;
                }else{
                    searchPhrase = inputSearch.val();
                }

                if(searchPhrase.length > 3) {
                    searchTimeout = window.setTimeout(function () {
                        _doSearch();
                    }, 500);
                }else{
                    searchContainer.find('.search__related').hide();
                    searchContainer.find('.search__suggested').show();
                }
            });
        };

        _doSearch = function(){
            console.log('doing search for: '+searchPhrase);
            resultsContainer.html("");


            xhr = $.ajax({
                url: settings.ajax_url,
                type: 'post',
                dataType: 'json',
                error: function(){
                    console.log('error');
                    searchContainer.find('a.btn_results').attr('href', '#');
                },
                data: {
                    action: 'post_search',
                    phrase: searchPhrase
                },
                success: function (data) {
                    if(data.data.length > 0) {
                        $.each(data.data, function (k, e) {
                            resultsContainer.append('<div class="search__suggestion"><a href="' + e.permalink + '"><h4>' + e.title + '</h4><p>' + e.excerpt + '</p></a></div>');
                        });

                        searchContainer.find('a.btn_results').attr('href', '/search/?search=' + searchPhrase).show();
                        searchContainer.find('.search__related').fadeIn();
                        searchContainer.find('.search__suggested').hide();
                        _findFirstLastFocusable();
                    }else{
                        resultsContainer.html('No results found. Please amend your search.');
                        searchContainer.find('a.btn_results').hide()
                        _findFirstLastFocusable();
                    }
                }
            });
        };

        _openSearch = function() {
            searchContainer.show();
            searchContainer.addClass('search--open');
            
            searchContainer.find('.search__related').hide();
            searchContainer.find('.search__suggested').fadeIn();
            
            searchContainer.on('keydown', _tabTrap);
            $('body').addClass("overflow");
            _findFirstLastFocusable();
            firstFocusable.focus();
        };

        _closeSearch = function () {
            searchContainer.removeClass('search--open');
            
            
            inputSearch.blur();
            openCtrl.focus();
            searchContainer.off('keydown', _tabTrap);
            inputSearch.val('');
            searchPhrase = "";
            searchContainer.find('a.btn_results').attr('href', '#');
            resultsContainer.html("");
            $('body').removeClass("overflow");
            if(prefersReduced){
                searchContainer.hide();
            }
            if(!transitionListenerAdded){
                searchContainer.on('transitionend', _hideContainer);
            }
            
        };

        _hideContainer = function(){
            searchContainer.hide();
            searchContainer.off('transitionend',_hideContainer);
        }
        _tabTrap = function(e){
            if(e.keyCode === 9){
                if(e.shiftKey){
                    if(document.activeElement === firstFocusable){
                        e.preventDefault();
                        lastFocusable.focus();
                    }
                }else{
                    if(document.activeElement === lastFocusable){
                        e.preventDefault();
                        firstFocusable.focus();
                    }
                }
            }
        };

        _findFirstLastFocusable = function(){
            var focusableElements = searchContainer[0].querySelectorAll('*');
            focusableElements = Array.from(focusableElements);
            focusableElements = focusableElements.filter(function(el){
                return _isFocusable(el);
            });

            firstFocusable = focusableElements[0];
            lastFocusable = focusableElements[focusableElements.length - 1];
        };

        _isFocusable = function(element){
                if (element.tabIndex < 0) {
                    return false;
                }
    
                if (element.disabled) {
                    return false;
                }
                if(!element.offsetParent){
                    return false;
                }
                if(!element.checkVisibility()){
                    return false;
                }

                switch (element.nodeName) {
                    case "A":
                        return !!element.href && element.rel != "ignore";
                    case "INPUT":
                        return element.type != "hidden";
                    case "BUTTON":
                    case "SELECT":
                    case "TEXTAREA":
                        return true;
                    default:
                        return false;
                }
        }

		__init = function(){
           	openCtrl = $('.search_btn'),
            closeCtrl = $('#btn-search-close'),
            searchContainer = $('.search'),
            inputSearch = searchContainer.find('.search__input');
            resultsContainer = searchContainer.find('.search_suggestions');
            searchContainer.hide();
            _findFirstLastFocusable();
            prefersReduced =  window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||window.matchMedia("(prefers-reduced-motion: reduce)").matches ==true;
            _initEvents();
		};


        __init();
    }

})(jQuery);